import * as React from "react";
import { toast } from "react-toastify";
import {
  getAccountInfo,
  updateEmailPreferences,
} from "../../../../api/rest-apis";

interface PersonalProps {}

interface PersonalState {
  firstName: string;
  lastName: string;
  email: string;
  provider: string;
  unsubscribed: boolean;
  isUpdatingPreference: boolean;
  isLoadingAccount: boolean;
}

class Personal extends React.Component<PersonalProps, PersonalState> {
  state: PersonalState = {
    firstName: "",
    lastName: "",
    email: "",
    provider: "",
    unsubscribed: false,
    isUpdatingPreference: false,
    isLoadingAccount: true,
  };

  componentDidMount() {
    this.getAccountInfo();
  }

  async getAccountInfo() {
    try {
      const response: any = await getAccountInfo();
      const firstName = response?.firstName || "";
      const lastName = response?.lastName || "";
      const provider = response?.provider || "";
      this.setState({
        firstName,
        lastName,
        email: response?.email || "",
        provider: provider
          ? provider.charAt(0).toUpperCase() + provider.slice(1)
          : "",
        unsubscribed: Boolean(response?.unsubscribed),
        isLoadingAccount: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({ isLoadingAccount: false });
    }
  }

  handleSubscriptionToggle = async () => {
    const { isLoadingAccount, isUpdatingPreference, unsubscribed } = this.state;
    if (isLoadingAccount || isUpdatingPreference) {
      return;
    }

    const nextUnsubscribed = !unsubscribed;
    this.setState({ isUpdatingPreference: true });

    try {
      await updateEmailPreferences({ unsubscribed: nextUnsubscribed });
      this.setState({ unsubscribed: nextUnsubscribed });

      toast.success(
        nextUnsubscribed
          ? "You’ll stop receiving character campaign emails. Toggle again any time to resubscribe."
          : "Subscribed! We’ll resume sending character emails to your inbox."
      );
    } catch (error) {
      console.error(error);
      toast.error(
        "We couldn't update your email preference. Please try again shortly."
      );
    } finally {
      this.setState({ isUpdatingPreference: false });
    }
  };

  render() {
    const { unsubscribed, isUpdatingPreference, isLoadingAccount } =
      this.state;
    const subscribed = !unsubscribed;
    const toggleDisabled = isLoadingAccount || isUpdatingPreference;

    return (
      <>
        <div className="bookish-input-group mt-4">
          <p className="bookish-input-label">
            Email <span className="required">*</span>
          </p>
          <input
            type="text"
            className="bookish-input-field"
            name="firstName"
            value={this.state.email}
            disabled
          />
        </div>
        <div className="bookish-input-group mt-4">
          <p className="bookish-input-label">
            First Name <span className="required">*</span>
          </p>
          <input
            type="text"
            className="bookish-input-field"
            name="firstName"
            value={this.state.firstName}
            disabled
          />
        </div>
        <div className="bookish-input-group mt-4">
          <p className="bookish-input-label">
            Last Name <span className="required">*</span>
          </p>
          <input
            type="text"
            className="bookish-input-field"
            name="firstName"
            value={this.state.lastName}
            disabled
          />
        </div>

        <div className="bookish-input-group mt-4">
          <p className="bookish-input-label">
            Sign In Option <span className="required">*</span>
          </p>
          <input
            type="text"
            className="bookish-input-field"
            name="firstName"
            value={this.state.provider}
            disabled
          />
        </div>

        {/* <div className="bookish-input-group mt-4">
          <button className="bookish-cancel-btn">Change password</button>
        </div> */}

        <div className="bookish-input-group mt-10 bg-[#FFF9F6] border border-[#F4E3DC] rounded-3xl p-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="bookish-input-label">Character emails</p>
              <p className="text-sm text-[#6B4E57] leading-relaxed">
                Subscribe to character emails.
              </p>
              <p className="mt-2 text-xs font-semibold uppercase tracking-wide text-[#C17A5C]">
                {subscribed ? "Subscribed" : "Unsubscribed"}
              </p>
            </div>
            <button
              type="button"
              onClick={this.handleSubscriptionToggle}
              disabled={toggleDisabled}
              className={`relative w-16 h-8 rounded-full transition-all duration-300 ${
                subscribed ? "bg-[#EA5E5E]" : "bg-gray-300"
              } ${toggleDisabled ? "opacity-60 cursor-not-allowed" : ""}`}
              aria-pressed={subscribed}
              aria-label="Toggle character email updates"
            >
              <span
                className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow transition-transform duration-300 ${
                  subscribed ? "translate-x-8" : "translate-x-0"
                }`}
              ></span>
            </button>
          </div>
          {isUpdatingPreference && (
            <p className="text-xs text-[#C17A5C] font-semibold mt-2">
              Saving your preference…
            </p>
          )}
        </div>
      </>
    );
  }
}

export default Personal;
